import { useState } from 'react'

import { getLatestVersion } from '@/changelog/versions'
import type { ChangelogVersion } from '@/changelog/versions'

const CHANGELOG_STORAGE_KEY = 'changelog_last_seen_version'

type UseChangelogReturn = {
  shouldShowPopup: boolean
  latestVersion: ChangelogVersion | undefined
  markAsSeen: () => void
}

const useChangelog = (): UseChangelogReturn => {
  const latestVersion = getLatestVersion()
  const currentVersion = import.meta.env.VITE_APP_VERSION as string | undefined

  const [shouldShowPopup, setShouldShowPopup] = useState<boolean>(() => {
    if (!currentVersion) return false

    try {
      const lastSeenVersion = localStorage.getItem(CHANGELOG_STORAGE_KEY)
      return lastSeenVersion !== currentVersion
    } catch {
      return false
    }
  })

  const markAsSeen = () => {
    if (!currentVersion) return

    try {
      localStorage.setItem(CHANGELOG_STORAGE_KEY, currentVersion)
      setShouldShowPopup(false)
    } catch {
      // silently fail
    }
  }

  return {
    shouldShowPopup,
    latestVersion,
    markAsSeen,
  }
}

export default useChangelog
